"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var checkPlaceholderContent = function checkPlaceholderContent(title) {
    if (!title)
        return false;
    return title.toLowerCase().indexOf("placeholder") > -1;
};
exports.default = checkPlaceholderContent;
